import { render, staticRenderFns } from "./ListBanks.vue?vue&type=template&id=0aaf7b98&"
import script from "./ListBanks.vue?vue&type=script&lang=js&"
export * from "./ListBanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports